import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import React from 'react'

import { Button, DropdownMenu, useBreakpoint } from 'slab'

interface PlanYearPickerProps {
  planYears: number[]
  selectedPlanYear: number
  onPlanYearChange: (year: number) => void
}

export const PlanYearPicker: React.FC<PlanYearPickerProps> = ({ planYears, selectedPlanYear, onPlanYearChange }) => {
  const { breakpointIsAtLeast } = useBreakpoint()

  // Remove any possible duplicates
  const uniquePlanYears = Array.from(new Set(planYears))
  // Enforce descending order
  const sortedPlanYears = uniquePlanYears.sort((a, b) => b - a)

  // Do not show "Plan year" text on mobile
  const buttonText = breakpointIsAtLeast('lg') ? `Plan year ${selectedPlanYear}` : `${selectedPlanYear}`

  return (
    <DropdownMenu
      trigger={({ open }) => (
        <Button size='large' rightIcon={open ? ChevronUpIcon : ChevronDownIcon}>{buttonText}</Button>
      )}
    >
      {sortedPlanYears.map((year) => (
        <DropdownMenu.Item
          key={year}
          onSelect={() => year !== selectedPlanYear && onPlanYearChange?.(year)}
          disabled={year === selectedPlanYear}
        >
          {year}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu>
  )
}

export default PlanYearPicker
